module.exports = __webpack_public_path__ + "static/media/1.38758366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16013/1.jpg
// module id = 506
// module chunks = 0